
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div className="md:col-span-2">
            <img 
              src="https://static.readdy.ai/image/16bc9533d1fb7c21d8b86a1aa65053e9/c32bedfeacbc58798bd6a680fa348e8e.jfif" 
              alt="Concierge & DPC Growth Network" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-300 mb-6 max-w-md">
              Connecting qualified patients with concierge and direct primary care practices across the United States. Performance-based lead generation that grows your practice.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-3">
              <li><a href="#services" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Lead Generation</a></li>
              <li><a href="#services" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Patient Matching</a></li>
              <li><a href="#services" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Practice Growth</a></li>
              <li><a href="#pricing" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Pricing</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Company</h3>
            <ul className="space-y-3">
              <li><a href="#how-it-works" className="text-gray-300 hover:text-white transition-colors cursor-pointer">How It Works</a></li>
              <li><a href="#contact" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Contact Us</a></li>
              <li><a href="/privacy" className="text-gray-300 hover:text-white transition-colors cursor-pointer">Privacy Policy</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm">
              <p>© {currentYear} Concierge & DPC Growth Network.</p>
              <p className="mt-1">
                A division of{' '}
                <a 
                  href="https://conciergemd.marketing" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors cursor-pointer underline"
                >
                  Concierge Medical Marketing LLC
                </a>
                . All rights reserved.
              </p>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
}
